import React, { useState } from 'react';
import './AlphabetLesson.css';

const AlphabetLessonA = () => {
  const [upperTraced, setUpperTraced] = useState(false);
  const [lowerTraced, setLowerTraced] = useState(false);
   

  const playPronunciation = () => {
    const audio = new Audio('/assets/audio/a_intro.mp3');
    audio.play();
  };

  const handleTrace = (type) => {
    if (type === 'upper') {
        setUpperTraced(true);
    } else if (type === 'lower') {
        setLowerTraced(true);
    }
    };

  return (
    <main className="alphabet-lesson">
      <h1>Letter A Lesson</h1>

      <section className="pronunciation">
        <p>Let's learn the letter A! Listen and repeat:</p>
        <button onClick={playPronunciation}>🔊 Say "A"</button>
      </section>

      <section className="tracing-section">
        <div className="trace-box">
          <p>Trace the uppercase letter A</p>
          <svg viewBox="0 0 100 100" className="trace-svg" onClick={() => handleTrace('upper')}>
             
            <path
                d="M10 90 L50 10 L90 90"  // Left stroke to top, then down right
                stroke={upperTraced ? 'green' : 'gray'}
                strokeWidth="5"
                fill="none"
                strokeLinecap="round"
            />
            <path
                d="M30 60 L70 60"         // Horizontal crossbar
                stroke={upperTraced ? 'green' : 'gray'}
                strokeWidth="5"
                fill="none"
                strokeLinecap="round"
            />
            </svg>
        </div>

        <div className="trace-box">
            <p>Trace the lowercase letter a</p>
            <svg viewBox="0 0 100 100" className="trace-svg" onClick={() => handleTrace('lower')}>
  {/* Body of the "a" */}
  <path
    d="M35 60
       Q35 45 50 45
       Q65 45 65 60
       Q65 75 50 75
       Q35 75 35 60
       Z"
    stroke={lowerTraced ? 'green' : 'gray'}
    strokeWidth="5"
    fill="none"
    strokeLinecap="round"
  />

  {/* Hooked top/terminal */}
  <path
    d="M65 45
       Q60 30 50 30
       Q45 30 45 40"
    stroke={lowerTraced ? 'green' : 'gray'}
    strokeWidth="5"
    fill="none"
    strokeLinecap="round"
  />
</svg>

            </div>
      </section>

      <section className="examples">
        <p>A is for:</p>
        <ul>
          <li>🍎 Apple</li>
          <li>🐜 Ant</li>
          <li>🚑 Ambulance</li>
        </ul>
      </section>

      <section className="next-prompt">
        <p><strong>Now it’s your turn!</strong> Try tracing both letters with your finger or mouse.</p>
        {upperTraced && lowerTraced && <p className="success">✅ Great job! You're ready for the next letter!</p>}
      </section>
    </main>
  );
};

export default AlphabetLessonA;
